import { useContext } from "react";
import { GameContext } from "../context/GameContext";
import MatchLetterButton from "./MatchLetterButton";

export default function MatchLettersRecipient() {
  const { matchLetters } = useContext(GameContext);
  return (
    <>
      <div className="flex justify-between gap-1">
        {matchLetters.map((letter, index) => (
          <MatchLetterButton letter={letter} key={index} />
        ))}
      </div>
    </>
  );
}
